import { Pipe, PipeTransform } from '@angular/core';
 
@Pipe({
  name: 'join'
})
export class JoinPipe implements PipeTransform {
 
  transform(array: any[], separator: string = ', '): string {
    if (!Array.isArray(array) || array.length === 0) return '';
    return array.filter(val => val !== null && val !== undefined && val !== '').join(separator);
  }
 
}